module.exports = __webpack_public_path__ + "img/emotion-neutral.18ca60fa.svg";